import React from 'react';
import {
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  useToast,
  Text,
} from '@chakra-ui/react';
import useAxios from 'axios-hooks';
import { API_ROUTES } from 'utils/constant';
import { ModalType } from 'utils/constant';

const ChangeLimitModal = ({ isOpen, settingDetail, onClose, refetchData }) => {
  const cancelRef = React.useRef();
  const toast = useToast();
  const [{ loading }, deleteSettingApi] = useAxios(
    {
      url: API_ROUTES.ChangeLimitSMTPServer,
      method: 'post',
    },
    { manual: true }
  );

  const handleSuccess = () => {
    toast({
      title: 'Thay đổi limit thành công',
      status: 'success',
      duration: 9000,
      isClosable: true,
    });
    refetchData?.();
    onClose?.(ModalType.ChangeLimit);
  };

  const handleError = error => {
    toast({
      title: error?.response?.data?.errors?.[0]?.msg || error?.response?.data?.msg || 'Thay đổi limit không thành công',
      status: 'error',
      duration: 9000,
      isClosable: true,
    });
  };

  const onDeleteChannel = () => {
    toast.closeAll();
    deleteSettingApi({
      data: { id: settingDetail?._id },
    })
      .then(res => {
        handleSuccess();
      })
      .catch(error => {
        handleError(error);
      });
  };

  return (
    <>
      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={() => {
          onClose?.(ModalType.ChangeLimit);
        }}
        isOpen={isOpen}
        isCentered
      >
        <AlertDialogOverlay />

        <AlertDialogContent>
          <AlertDialogHeader textTransform="uppercase">Thay đổi limit</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            <Text>Bạn có chắc chắn thay đổi limit cho máy chủ SMTP này không?</Text>
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button
              ref={cancelRef}
              onClick={() => {
                onClose?.(ModalType.ChangeLimit);
              }}
            >
              Hủy
            </Button>
            <Button colorScheme="blue" ml={3} isLoading={loading} onClick={onDeleteChannel}>
              Cập nhật
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default ChangeLimitModal;
